(function () {
	document.addEventListener('DOMContentLoaded', () => {
		const gtagId = document.querySelector('[data-gtag-id]')?.getAttribute('data-gtag-id');
		if (!gtagId) {
			console.error('Gtag ID not found');
			return;
		}

		const getGtagValue = (target, field) => {
			return new Promise((resolve) => {
				if ('gtag' in window) {
					window.gtag('get', target, field, (value) => {
						resolve(value);
					});
				}
			});
		};

		async function captureGaData() {
			const clientId = await getGtagValue(gtagId, 'client_id');
			const sessionId = await getGtagValue(gtagId, 'session_id');

			if (!clientId || !sessionId) {
				console.error('captureGaData: Client ID or session ID not found');
				return;
			}

			return { clientId, sessionId };
		}

		captureGaData()
			.then((data) => {
				if (!data) {
					console.error('captureGaData: Data not found');
					return;
				}
        
				fetch('/cart/update.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						attributes: {
							'ga_client_id': data.clientId,
							'ga_session_id': data.sessionId,
						},
					}),
				});
			});
	});
})();
